import type { ReactNode } from 'react';

interface SectionProps {
  title?: string;
  description?: string;
  right?: ReactNode;
  children: ReactNode;
  /** 본문 패딩 제거 (테이블 등 풀-블리드 콘텐츠용) */
  noPadding?: boolean;
  className?: string;
}

/**
 * 디테일/대시보드용 섹션 카드
 */
export function Section({
  title,
  description,
  right,
  children,
  noPadding = false,
  className = '',
}: SectionProps) {
  return (
    <section
      className={`overflow-hidden rounded-lg border border-gray-200 bg-white ${className}`}
    >
      {(title || right) && (
        <div className="flex items-center justify-between gap-2 border-b border-gray-200 px-4 py-3">
          <div className="min-w-0">
            {title && (
              <h2 className="truncate text-sm font-semibold text-gray-900">
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-0.5 text-xs text-gray-500">{description}</p>
            )}
          </div>
          {right && <div className="flex-shrink-0">{right}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'p-4'}>{children}</div>
    </section>
  );
}

interface DescListProps {
  items: Array<{ label: string; value: ReactNode }>;
  /** md 이상에서 한 줄에 표시할 컬럼 수 */
  cols?: 1 | 2 | 3;
}

/**
 * 라벨-값 그리드 (디테일 페이지용)
 */
export function DescList({ items, cols = 2 }: DescListProps) {
  const colsClass = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  }[cols];
  return (
    <dl className={`grid gap-3 ${colsClass}`}>
      {items.map(({ label, value }, i) => (
        <div key={i} className="min-w-0">
          <dt className="text-xs font-medium text-gray-500">{label}</dt>
          <dd className="mt-0.5 text-sm text-gray-900">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
